import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {CmsBannerComponent} from '../cms-banner/cms-banner.component';
import {BreadcrumbsComponent} from "../breadcrumbs/breadcrumbs.component";



export const AppFooterComponent = observer(class AppFooterComponent extends OrbitComponent<{}> {
  render() {
    const footerConfiguration  = this.services.configuration.data && this.services.configuration.data.footer;

    if(!footerConfiguration) {
      return null;
    }

    return (
        <>
          <BreadcrumbsComponent key={`BREAD_CRUMBS`}/>
          <CmsBannerComponent componentID={footerConfiguration.componentID}
                              templateID={footerConfiguration.templateID}
                              contentID={footerConfiguration.contentID}
                              fallbackUrl={this.services.theme.currentTheme.assets.fallbackCMSComponent.defaultFooter_html.toString()}
                              showPlaceholder={false}/>
        </>
    );
  }
});
